import { queryOptions } from '@tanstack/react-query'
import { propertyApi, propertyPIApi } from './api'
import { PropertyFilter, PropertyInstanceFilter } from './models'
import { Pagination } from '@thinknimble/tn-models'

export const propertyQueries = {
  all: () => ['properties'],
  sireCities: () =>
    queryOptions({
      queryKey: [...propertyQueries.all(), 'sire-cities'],
      queryFn: () => propertyApi.csc.listSireCities(),
      staleTime: Infinity,
    }),
  retrieve: (id: string) =>
    queryOptions({
      queryKey: [...propertyQueries.all(), id],
      queryFn: () => propertyApi.retrieve(id),
      enabled: Boolean(id),
    }),
  list: ({
    filters,
    pagination,
    paginationCallback,
  }: {
    filters?: Partial<PropertyFilter>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  } = {}) =>
    queryOptions({
      queryKey: [...propertyQueries.all(), { filters, pagination }],
      queryFn: async () => {
        const res = await propertyApi.list({ filters, pagination })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
      enabled: true,
    }),
}
export const propertyPIQueries = {
  all: () => ['property-price-instances'],
  retrieve: (id: string) =>
    queryOptions({
      queryKey: [...propertyPIQueries.all(), id],
      queryFn: () => propertyPIApi.retrieve(id),
      enabled: Boolean(id),
    }),
  list: ({
    filters,
    pagination,
  }: {
    filters?: Partial<PropertyInstanceFilter>
    pagination?: Pagination
  }) =>
    queryOptions({
      queryKey: [...propertyPIQueries.all(), filters, pagination],
      queryFn: () => propertyPIApi.list({ filters, pagination }),
      enabled: true,
    }),
}
